import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { heroTag, productImage, productImageAlt, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-background" data-id="element-85" data-mp="sa9n4zi4x3ps">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-86" data-mp="ncq2nhuufupe">
        <span className="flex-1 bg-primary" data-id="element-87" data-mp="neauv0tor1k3" />
        <span className="w-24 bg-highlight" data-id="element-88" data-mp="3d1sc51sntrv8" />
        <span className="flex-1 bg-primary" data-id="element-89" data-mp="3d2tm12xxw8bd" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-90" data-mp="3825wklpczzj9">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-highlight/50 bg-surface px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-foreground" data-id="element-91" data-mp="3j7zcjaz8recz">
          <ZapIcon className="h-4 w-4 text-highlight" aria-hidden="true" data-id="element-92" data-mp="30i18r72h87f5" /> {heroTag}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-93" data-mp="358rdqj6zq89b">
          <img src={productImage} alt={productImageAlt} className="mockup-glow mx-auto w-full" data-id="element-94" data-mp="2vgtzt4oll26w" />
        </motion.div>

        <div className="mt-9" data-id="element-95" data-mp="2lkqzm4db3dml">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-96" data-mp="2ll0eavswhycz">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-foreground" data-id="element-97" data-mp="s3ur9xru3ab5">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-primary/60 bg-surface px-3 py-2" data-id="element-98" data-mp="icrn2n3lyf7n">
              <Icon className="h-3.5 w-3.5 text-highlight" aria-hidden="true" data-id="element-99" data-mp="dbasf9bpvozi" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}